import { useRef, useState } from "react";

import { useSecurityPledge } from "../hooks/useSecurityPledge";
import { Button } from "../components/common/button";
import { Trans, useTranslation } from "react-i18next";
import { useAgreeSecurityPledge } from "../hooks/useAgreeSecurityPledge";
import { SetSessionToken } from "../utils/store";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { t } from "i18next";

const SecurityPledgePage = () => {
  const navigate = useNavigate();
  const [isAgreed, setIsAgreed] = useState(false);
  const agreeInFlightRef = useRef(false);
  const { securityPledge, isLoading, isError, error } = useSecurityPledge();
  const { agreeSecurityPledge, isPending } = useAgreeSecurityPledge();
  const { i18n } = useTranslation();
  const content = securityPledge?.content;
  const currentLanguage = i18n.resolvedLanguage;

  const onClickAgree = async () => {
    if (!securityPledge?.version || isPending || agreeInFlightRef.current) {
      return;
    }
    agreeInFlightRef.current = true;
    try {
      const response = await agreeSecurityPledge(securityPledge.version);
      // 보안 서약서 동의 상태 업데이트 된 상태 && 업데이트할 토큰이 내려온 경우 토큰 업데이트 후 메인 페이지로 이동
      if (
        response.sessionToken &&
        !response.constraints.securityPledgeRequired
      ) {
        SetSessionToken(response.sessionToken);
        navigate("/events/checkins");
      } else {
        toast.error(t("logingate_popup_pledge_error"));
      }
    } catch {
      toast.error(t("logingate_popup_pledge_error"));
    } finally {
      agreeInFlightRef.current = false;
    }
  };

  return (
    <div className={"flex flex-col h-full"}>
      <div className="p-4 flex-grow flex flex-col min-h-0 overflow-hidden">
        {isLoading && (
          <div className={"flex justify-center items-center"}>
            <span className={"loading loading-spinner loading-lg"}></span>
          </div>
        )}
        {isError && (
          <div className="text-center text-error mt-8">
            <Trans
              i18nKey="logingate_popup_pledge_error"
              components={{ br: <br /> }}
            />
            {error?.message && <p className="text-sm">{error.message}</p>}
          </div>
        )}

        <div className={"flex flex-col flex-1 min-h-0 gap-3"}>
          <div className={"relative flex-[9] min-h-0 flex flex-col"}>
            <textarea
              id={"content"}
              readOnly
              aria-readonly="true"
              className={
                "textarea textarea-bordered w-full flex-1 min-h-0 overflow-y-auto text-sm resize-none cursor-default bg-base-200/60 text-base-content focus:outline-none focus-visible:ring-2 focus-visible:ring-base-content/20"
              }
              value={content?.[currentLanguage as keyof typeof content]}
            />
          </div>

          <div className={"form-control flex-[1] shrink-0"}>
            <label className={"label cursor-pointer justify-start gap-3"}>
              <input
                type={"checkbox"}
                className={"checkbox checkbox-primary"}
                checked={isAgreed}
                onChange={(e) => setIsAgreed(e.target.checked)}
              />
              <div>
                <span className={"label-text text-sm"}>
                  {t("logingate_popup_pledge_agree")}
                </span>
              </div>
            </label>
          </div>
          <Button
            type={"button"}
            className={"btn btn-primary w-full rounded-md"}
            disabled={!isAgreed || isPending}
            loading={isPending}
            onClick={onClickAgree}
          >
            {t("common_dialog_yes")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SecurityPledgePage;
